var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Bold",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#C12026;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M301.2,256l82.8-82.8c11.7-13.3,10.4-33.5-2.9-45.2c-12.1-10.6-30.2-10.6-42.3,0L256,210.8l-83-83 c-12.5-12.5-32.8-12.5-45.3,0s-12.5,32.8,0,45.3l83,83L128,338.8c-13.2,11.8-14.3,32-2.5,45.2c11.8,13.2,32,14.3,45.2,2.5 c0.9-0.8,1.7-1.6,2.5-2.5l82.8-82.8l82.7,82.8c12.5,12.5,32.8,12.5,45.3,0c12.5-12.5,12.5-32.8,0-45.3L301.2,256z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseMenu);
export default __webpack_public_path__ + "static/media/close-menu.1bac2884db959b9f909e43b19a3047cb.svg";
export { ForwardRef as ReactComponent };